import API from "../config/api.js";

export const ExpenseService =  {
  getExpenseTypes(search = '', page = 1) {
    return API.get('/api/expense-types', {
      params : {
        search,
        page,
      }
    });
  },
  createExpenseType(data) {
    return API.post('/api/expense-types/create', data);
  },
  updateExpenseType(id, data) {
    return API.put(`/api/expense-types/update/${id}`, data);
  },
  deleteExpenseType(id) {
    return API.delete(`/api/expense-types/delete/${id}`);
  },

  async getExpenseTypeDetails(id) {
    const response = await API.get(`/api/expense-types/${id}`);
    return response.data;
  },

  async createExpense(formData) {
    const response = await API.post("api/expenses/create", formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  async updateExpense(expenseId, formData) {
    return API.put(`api/expenses/update/${expenseId}`, formData,{
      headers: { 'Content-Type': 'multipart/form-data' },
    }); 
  },

  async deleteExpense(id) {
    const response = await API.delete(`/api/expenses/delete/${id}`);
    return response.data;
  },

  getBankAccounts(search = '') {
    return API.get('/api/banks/getbranchbankaccounts', {
      params : {
        search,
      }
    });
  },
  getBanks(){
    return API.get('/api/companyBankAcc/getbanks');
  },

  async getExpenses(search = '', page = 1) {
    return API.get('/api/expenses/', {
      params : {
        search,
        page,
      }
    });
  },

  async getExpenseDetails(id) {
    const response = await API.get(`/api/expenses/${id}`);
    return response.data;
  },

  async postExpense(id) {
    const response = await API.post(`/api/expenses/post/${id}`);
    return response.data;
  },

  getPaymentMethods() {
    return API.get("/api/payment-methods/list");
  },
  
};
